import { FC } from 'react';
import ArticleOverviewPanel from './ArticleOverviewPanel.component';
import ArticleScannerTable from './ArticleScannerTable.component';
import NonPremiumSubscriptionDisplayMessage, {
  doesClientHavePremiumPackage,
} from '../NonPremiumSubscriptionDisplay/NonPremiumSubscriptionDisplayMessage.component';
import { Grid } from '@mui/material';
import { FundInfoComponentProps } from '../../../layout/general/SimpleGeneralPageWrapper';
import { QueryBoundary } from '../../../utilityComponents/QueryBoundary';
import {
  EsgPages,
  useEsgFundData,
  type EsgPortfolioSummaryPageModel,
} from '../../../../api/rs-hg/esg';

const ArticleScanner: FC<FundInfoComponentProps> = ({
  fundName,
  fundId,
  positionDate,
}) => {
  const portfolioSummaryQuery = useEsgFundData(
    fundId,
    positionDate,
    EsgPages.ARTICLE_SCANNER,
  );

  return (
    <QueryBoundary<EsgPortfolioSummaryPageModel>
      isLoading={portfolioSummaryQuery.isLoading}
      isFetching={portfolioSummaryQuery.isFetching}
      isError={portfolioSummaryQuery.isError}
      error={portfolioSummaryQuery.error}
      data={
        portfolioSummaryQuery.data?.data &&
        Object.keys(portfolioSummaryQuery.data.data).length > 0 &&
        !('no data' in portfolioSummaryQuery.data.data)
          ? portfolioSummaryQuery.data
          : null
      }
      loadingMessages={['Loading ESG Data...', '...']}
      errorMessage="No ESG Data Found"
      noDataMessage="No ESG Data Found"
    >
      {(pageModel) =>
        doesClientHavePremiumPackage(pageModel.data) ? (
          <Grid container spacing={2} style={{ padding: 8 }}>
            <ArticleOverviewPanel data={pageModel.data} fundName={fundName} />
            <ArticleScannerTable data={pageModel.data} />
          </Grid>
        ) : (
          <NonPremiumSubscriptionDisplayMessage />
        )
      }
    </QueryBoundary>
  );
};

export default ArticleScanner;
